/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsExternalEhrPatientLeadsInner } from './HchbPatientDetailsExternalEhrPatientLeadsInner';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerToJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatientLeadsInner';

/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatient
 */
export interface HchbPatientDetailsExternalEhrPatient {
    /**
     * 
     */
    patient_id?: string;
    /**
     * 
     */
    type?: HchbPatientDetailsExternalEhrPatientTypeEnum;
    /**
     * 
     */
    details_push_date?: string;
    /**
     * 
     */
    details_extraction_date?: string;
    /**
     * 
     */
    is_extracting_details?: boolean;
    /**
     * 
     */
    leads?: Array<HchbPatientDetailsExternalEhrPatientLeadsInner>;
    /**
     * 
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH',
    Kinnser: 'KINNSER',
} as const;
export type HchbPatientDetailsExternalEhrPatientTypeEnum = typeof HchbPatientDetailsExternalEhrPatientTypeEnum[keyof typeof HchbPatientDetailsExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatient interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatient(value: object): value is HchbPatientDetailsExternalEhrPatient {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientFromJSON(json: any): HchbPatientDetailsExternalEhrPatient {
    return HchbPatientDetailsExternalEhrPatientFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'] == null ? undefined : json['patient_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'details_push_date': json['details_push_date'] == null ? undefined : json['details_push_date'],
        'details_extraction_date': json['details_extraction_date'] == null ? undefined : json['details_extraction_date'],
        'is_extracting_details': json['is_extracting_details'] == null ? undefined : json['is_extracting_details'],
        'leads': json['leads'] == null ? undefined : ((json['leads'] as Array<any>).map(HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSON)),
        'is_screener_document_upload_in_progress': json['is_screener_document_upload_in_progress'] == null ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': json['is_additional_document_upload_in_progress'] == null ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': json['is_generated_document_upload_in_progress'] == null ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function HchbPatientDetailsExternalEhrPatientToJSON(json: any): HchbPatientDetailsExternalEhrPatient {
    return HchbPatientDetailsExternalEhrPatientToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientToJSONTyped(value?: HchbPatientDetailsExternalEhrPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'type': value['type'],
        'details_push_date': value['details_push_date'],
        'details_extraction_date': value['details_extraction_date'],
        'is_extracting_details': value['is_extracting_details'],
        'leads': value['leads'] == null ? undefined : ((value['leads'] as Array<any>).map(HchbPatientDetailsExternalEhrPatientLeadsInnerToJSON)),
        'is_screener_document_upload_in_progress': value['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': value['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': value['is_generated_document_upload_in_progress'],
    };
}

